import makeApiCall from "./axiosIndex";

const workCategoryApi = {
    createWorkCategory: (data: any): Promise<any> =>
        makeApiCall<any>({
            method: "post",
            url: "buyer/createWorkCategories",
            data,
        }),

    fetchWorkCategories: (): Promise<any> =>
        makeApiCall<any>({ method: "get", url: "/buyer/fetchWorkCategories" }),

    fetchWorkCategoryById: (id: any): Promise<any> =>
        makeApiCall<any>({
            method: "get",
            url: `/buyer/updateWorkCategoriesById`,
            params: { id },
        }),

    updateWorkCategoryById: (id: any, data: any): Promise<any> =>
        makeApiCall<any>({
            method: "put",
            url: `/buyer/updateWorkCategoriesById`,
            params: { id },
            data,
        }),

    fetchCategoryType: (): Promise<any> =>
        makeApiCall<any>({ method: "get", url: "/misc/workCategoryMaster" }),
};

export default workCategoryApi;
